import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { DateInputControl } from "../../controls";
import { H3Input, H3Datetime } from "h3-mobile-vue";
import { dateFormatter } from '../../utils';
import TimeRangesSelect from "./time-ranges-select.vue";
import ControlBack from "../../directives/control-back";
let InputDateRange = class InputDateRange extends DateInputControl {
    constructor() {
        super(...arguments);
        this.showModals = [false, false];
        this.visible = false;
    }
    show(index) {
        this.showModals.splice(index, 1, true);
    }
    close(index) {
        this.showModals.splice(index, 1, false);
    }
    onConfirm(index, value) {
        const vals = this.ctrl.value.map((x) => x);
        vals[index] = value;
        this.ctrl.value = vals;
        //清除快捷选择状态
        if (this.visible) {
            this.$refs.timeRangesSelect.clear();
        }
    }
    mounted() {
        if (this.showTimeRanges) {
            if (this.showTimeRanges()) {
                this.visible = true;
            }
        }
    }
    change(val) {
        if (this.ctrl.value && this.ctrl.value.length > 1) {
            this.ctrl.value[0] = this.formatDate(val.start.format(this.format));
            this.ctrl.value[1] = this.formatDate(val.end.format(this.format));
            this.ctrl.value = this.ctrl.value.slice(0); //触发计算属性更新
        }
    }
    get begin() {
        if (this.ctrl.value && this.ctrl.value.length > 1) {
            return this.formatDate(this.ctrl.value[0]);
        }
        return "";
    }
    get end() {
        if (this.ctrl.value && this.ctrl.value.length === 2) {
            return this.formatDate(this.ctrl.value[1]);
            // return dateFormatter(this.ctrl.value[1],'YYYY-MM-DD');
            // return this.ctrl.value[1];
        }
        return "";
    }
    get beginLabel() {
        return this.control.options.name + '开始';
    }
    get endLabel() {
        return this.control.options.name + '结束';
    }
    formatDate(val) {
        if (typeof val === 'string') {
            return val;
        }
        else if (val instanceof Date) {
            return dateFormatter(val, this.format);
        }
    }
    clearVal(index) {
        // debugger;
        this.ctrl.value[index] = '';
        this.ctrl.value = [...this.ctrl.value];
        // this.val =  '';
        // this.ctrl.value = null;
    }
};
tslib_1.__decorate([
    Inject()
], InputDateRange.prototype, "showTimeRanges", void 0);
InputDateRange = tslib_1.__decorate([
    Component({
        name: "input-date-range",
        components: {
            H3Input,
            H3Datetime,
            TimeRangesSelect
        },
        directives: {
            ControlBack
        }
    })
], InputDateRange);
export default InputDateRange;
